import * as React from 'react';
import { UIEvent, getPageX, getPageY } from '../../uievent';
import { Point } from '../../drawing/types'; // TODO make it global
import { Rectangle } from 'ark-common';
import { zIndex } from '../../constants';

export interface ZoomingRegionSelectorProps {
  onRegionSelected: (rect: Rectangle) => void;
}

interface InactiveState {
  dragging: false;
}

interface ActiveState {
  dragging: true;
  startX: number;
  startY: number;
  currentX: number;
  currentY: number;
}

type ZoomableRegionSelectorState = InactiveState | ActiveState;

class ZoomingRegionSelector
  extends React.PureComponent<ZoomingRegionSelectorProps, ZoomableRegionSelectorState> {

  public constructor(props: ZoomingRegionSelectorProps) {
    super(props);

    this.state = {
      dragging: false,
    };
  }

  private getClientPoint = (ev: UIEvent<SVGElement>): Point => {
    // FIXME : Not robust, not fast.
    const element = ev.currentTarget as SVGElement;
    const bounds = element.getBoundingClientRect();
    return {
      x: getPageX(ev) - bounds.left,
      y: getPageY(ev) - bounds.top,
    };
  }

  private handlePointerDown = (ev: UIEvent<SVGElement>): void => {
    const { x, y } = this.getClientPoint(ev);

    this.setState({
      dragging: true,
      startX: x,
      startY: y,
      currentX: x,
      currentY: y,
    });
  }

  private handlePointerMove = (ev: UIEvent<SVGElement>): void => {
    if (!this.state.dragging) {
      return;
    }

    const { x, y } = this.getClientPoint(ev);

    this.setState({
      dragging: true,
      currentX: x,
      currentY: y,
    });

    ev.preventDefault();
  }

  private handlePointerUp = (_ev: UIEvent<SVGElement>): void => {
    if (!this.state.dragging) {
      return;
    }

    const { startX, startY, currentX, currentY } = this.state;
    const x = Math.min(startX, currentX);
    const y = Math.min(startY, currentY);
    const width = Math.abs(currentX - startX);
    const height = Math.abs(currentY - startY);

    this.setState({ dragging: false });

    if (width > 10 && height > 10) {
      this.props.onRegionSelected({ x, y, width, height });
    }
  }

  private makeCurrentRect = () => {
    if (!this.state.dragging) {
      return null;
    }

    const { startX, startY, currentX, currentY } = this.state;
    const x = Math.min(startX, currentX);
    const y = Math.min(startY, currentY);
    const width = Math.abs(currentX - startX);
    const height = Math.abs(currentY - startY);

    return (
      <rect width={width} height={height} x={x} y={y} fill="rgba(0, 100, 255, 0.4)" />
    );
  }

  public render() {
    const style: React.CSSProperties = {
      position: 'absolute',
      left: '0',
      top: '0',
      width: '100%',
      height: '100%',
      cursor: 'crosshair',
      zIndex: zIndex.zoomingRegionSelector,
    };

    return (
      <svg
        style={style}
        onMouseDown={this.handlePointerDown}
        onMouseMove={this.handlePointerMove}
        onMouseUp={this.handlePointerUp}
        onTouchStart={this.handlePointerDown}
        onTouchMove={this.handlePointerMove}
        onTouchEnd={this.handlePointerUp}>
        {this.makeCurrentRect()}
      </svg>
    );
  }
}

export default ZoomingRegionSelector;
